import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Container } from "./ui-kit";

export default function PageHero({ label, title, subtitle, crumbs = [], image }) {
  return (
    <section className="relative overflow-hidden bg-emerald-950 text-white">
      {image && <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />}
      <div className="absolute inset-0 islamic-pattern opacity-40" />
      <Container className="relative py-16 lg:py-24">
        <nav className="flex flex-wrap items-center gap-1.5 text-xs font-medium text-emerald-100/70">
          <Link to="/" className="hover:text-white">Home</Link>
          {crumbs.map((c) => (
            <span key={c.label} className="flex items-center gap-1.5">
              <ChevronRight className="h-3 w-3 rtl:rotate-180" />
              {c.to ? <Link to={c.to} className="hover:text-white">{c.label}</Link> : <span className="text-white">{c.label}</span>}
            </span>
          ))}
        </nav>
        {label && <p className="mt-6 text-xs font-semibold uppercase tracking-[0.22em] text-gold-light">{label}</p>}
        <h1 className="mt-3 max-w-4xl font-display text-4xl font-bold leading-tight sm:text-5xl lg:text-6xl">{title}</h1>
        {subtitle && <p className="mt-5 max-w-2xl text-lg leading-relaxed text-emerald-50/80">{subtitle}</p>}
      </Container>
    </section>
  );
}
